import styled from "styled-components";
import Chip from "../Chip";
import ActionImageButton from "../DataTable/ActionImageButton";
import ListWithPagination from "../ListsWithPagination";
import { TableWithPagination } from "../TableWithPagination";

interface Props {
  data: {
    id: number;
    merchant_name: string;
    merchant_id: string;
    onboard_date: string;
    status: boolean;
  }[];
  currentPage: number;
  totalData: number;
  rowsPerPage: number;
  onEdit: (id: string) => void;
  isTableDataLoading: boolean;
  onPageChange: (page: number) => void;
}

const MerchantTable = ({
  data,
  onEdit,
  isTableDataLoading,
  totalData,
  currentPage,
  rowsPerPage,
  onPageChange,
}: Props) => {
  const columns = [
    {
      path: "merchant_name",
      label: "Merchant Name",
    },
    {
      path: "merchant_id",
      label: "Merchant ID",
    },
    {
      path: "onboard_date",
      label: "Onboard Date",
    },
    {
      key: "status",
      label: "Status",
      content: (merchant: {
        id: number | string;
        merchant_name: string;
        merchant_id: string;
        onboard_date: string;
        status: boolean;
      }) => (
        <Chip
          label={merchant.status ? "Active" : "Inactive"}
          variant={merchant.status ? "success" : "error"}
        />
      ),
    },
    {
      label: "Action",
      key: "edit",
      content: (merchant: {
        id: number | string | any;
        merchant_name: string;
        merchant_id: string;
        onboard_date: string;
        status: boolean;
      }) => (
        <ActionImageButton
          onClick={() => onEdit(merchant.id)}
          iconPath={require("../../assets/images/edit-icon.png")}
          label={"Edit Merchant"}
        />
      ),
    },
  ];
  return (
    <>
      <TableWrapper>
        <TableWithPagination
          onPageChange={onPageChange}
          totalData={totalData}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
        />
      </TableWrapper>
      <ListWrapper>
        <ListWithPagination
          onPageChange={onPageChange}
          totalData={totalData}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          title={"Merchant Details"}
          onRowClick={undefined}
        />
      </ListWrapper>
    </>
  );
};

const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;
const TableWrapper = styled.div`
  display: block;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export default MerchantTable;
